"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var react_1 = __importDefault(require("react"));
var styles_1 = require("@mui/material/styles");
var material_1 = require("@mui/material");
var react_router_dom_1 = require("react-router-dom");
var classnames_1 = __importDefault(require("classnames"));
var PREFIX = 'Link';
var classes = {
    link: "".concat(PREFIX, "-link"),
    active: "".concat(PREFIX, "-active"),
};
var StyledNavLink = (0, styles_1.styled)(react_router_dom_1.NavLink)((_a = {},
    _a["& .".concat(classes.link)] = {
        color: 'inherit',
        textDecoration: 'none',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        '&:hover': {
            textDecoration: 'underline',
        },
    },
    _a["& .".concat(classes.active)] = {
        textDecoration: 'underline',
    },
    _a));
var Link = function (_a) {
    var className = _a.className, _b = _a.to, to = _b === void 0 ? '#' : _b, _c = _a.asAnchor, asAnchor = _c === void 0 ? false : _c, _d = _a.shouldApplyActiveStyle, shouldApplyActiveStyle = _d === void 0 ? true : _d, _e = _a.shouldBeExact, shouldBeExact = _e === void 0 ? true : _e, _f = _a.hide, hide = _f === void 0 ? false : _f, targetBlank = _a.targetBlank, onClick = _a.onClick, children = _a.children, rel = _a.rel, other = __rest(_a, ["className", "to", "asAnchor", "shouldApplyActiveStyle", "shouldBeExact", "hide", "targetBlank", "onClick", "children", "rel"]);
    var navigate = (0, react_router_dom_1.useNavigate)();
    var match = (0, react_router_dom_1.useMatch)({
        path: to,
        end: shouldBeExact,
    });
    var allClasses = (0, classnames_1.default)(classes.link, className, shouldApplyActiveStyle && match && classes.active);
    if (hide) {
        return null;
    }
    if (onClick) {
        return ((0, jsx_runtime_1.jsx)(material_1.Box, __assign({}, other, { onClick: function (e) {
                onClick(e);
                if (to) {
                    if (asAnchor) {
                        window.location.href = to;
                    }
                    else {
                        navigate(to);
                    }
                }
            }, className: allClasses }, { children: children })));
    }
    if (asAnchor) {
        return ((0, jsx_runtime_1.jsx)(material_1.Link, __assign({}, other, { href: to, className: allClasses, target: targetBlank ? '_blank' : '_self', rel: rel }, { children: children })));
    }
    return ((0, jsx_runtime_1.jsx)(StyledNavLink, __assign({}, other, { to: to, className: allClasses }, { children: children })));
};
exports.default = Link;
